<template>
  <div class="flex flex-col gap-3 mb-4">
    <base-product-search-bar
      class="product-search-bar"
      :disabled="isLoadingRequest || !canRequest"
      placeholder="Vérifiez la disponibilité d'un produit"
      @select="handleProductSelection"
    />
    <request-state />
  </div>
</template>

<script lang="ts" setup>
import {computed, ref} from 'vue';
import BaseProductSearchBar from "@/product/components/BaseProductSearchBar.vue";
import {LegacyProduct} from "@/core/interfaces/Product";
import DisruptionLogisticsRequestService from "@/disruption-logistics/services/DisruptionLogisticsRequestService";
import RequestState from "@/disruption-logistics/components/request-state/RequestState.vue";
import {useDisruptionLogisticsRequestStore} from "@/stores/disruptionLogisticsRequest.store";
import {useRouter} from "vue-router";
import {storeToRefs} from "pinia";

const {replaceRoute = false} = defineProps<{
    replaceRoute?: boolean
}>();

const router = useRouter();

const isLoadingRequest = ref(false);

const {subscribed, remainingRequests} = storeToRefs(useDisruptionLogisticsRequestStore());

const canRequest = computed(() => {
    return subscribed.value || remainingRequests.value > 0;
});

const handleProductSelection = async (product: LegacyProduct) => {
    if (!product) {
        return;
    }

    isLoadingRequest.value = true;

    await DisruptionLogisticsRequestService.requestDisruptionLogisticsData(
        product,
        router,
        replaceRoute
    );

    isLoadingRequest.value = false;
};
</script>

<style>
:deep([type='text']:focus) {
    outline: none;
    border-width: 0 !important;
    outline-offset: 0 !important;
}
</style>